/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { DateRange, OptionMenu, TableSearch, WordDelete } from "../common/svg/AllSvg";
import DatePicker from "react-multi-date-picker";
import { useTranslation } from "react-i18next";
import Error from "../common/form/Error";
import NoSearch from "../common/form/NoSearch";
import EmptyList from "../common/form/EmptyList";
import PaginationComponent from "../common/form/PaginationComponent";
import { useDispatch, useSelector } from "react-redux";
import { url } from "../../shared/utils/url";
import useAxios from "../../shared/hooks/use-axios";
import { languages } from "../../shared/utils/languages";
import moment from "moment";
import { dataActions } from "../../shared/store/data-Slice";

const AlertWords = () => {
  const lang: string = useSelector((state: any) => state.ui.lang);
  const chatbotApiCall: boolean = useSelector((state: any) => state.data.chatbotApiCall);
  const { t } = useTranslation('common');
  const [data, setData] = useState<any>([1])
  const [loading, setLoading] = useState<boolean>(true)
  const [isError, setIsError] = useState<boolean>(false)
  const [search, setSearch] = useState<string>("")
  const [debouncedValue, setDebouncedValue] = useState<string>(search);
  const [searchFocus, setSearchFocus] = useState<boolean>(false)
  const [range, setRange] = useState<any[]>([null, null]);
  const [debouncedRange, setDebouncedRange] = useState<any[]>(range);
  const [rangeFocus, setRangeFocus] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
  let totalPages: number = Math.ceil(total / +size?.value);
  const loaderData: any[] = [1, 2, 3, 4, 5];
  const dispatch = useDispatch();

  const getData = async () => {
    try {
      setLoading(true)
      setIsError(false)
      const res: any = await useAxios.get(`${(!!lang ? lang : "en") + url?.alert_word_list}?page=${page}&size=${+size?.value}${!!debouncedValue ? `&search=${debouncedValue}` : ""}${!!debouncedRange[0] ? `&start_date=${debouncedRange[0].format("YYYY-MM-DD")}` : ""}${!!debouncedRange[1] ? `&end_date=${debouncedRange[1].format("YYYY-MM-DD")}` : ""}`);

      if (res && res.status === 200) {
        setData(res?.data?.results)
        setTotal(res?.data?.count)
        setLoading(false)
        dispatch(dataActions.setChatbotApiCall(false));
      }
    } catch (error) {
      setIsError(true)
      setLoading(false)
      console.error("error while fetching alert words", error);
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedRange(range);
    }, 500);

    return () => clearTimeout(timer);
  }, [range]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, [page, size, debouncedValue, debouncedRange])

  useEffect(() => {
    chatbotApiCall && getData();
  }, [chatbotApiCall])

  const handleDelete = async (id: any) => {
    try {
      const res: any = await useAxios.delete(`${url?.delete_word + id}/`);
      if (res && res.status === 204) {
        getData()
      }
    } catch (error) {
      console.error("error while delete word", error);
    }
  }

  return (
    <div className="w-full container h-full py-[30px] xlx:py-[40px] flex flex-col gap-[25px]">
      <div className="flex mms:items-center justify-end w-full mms:flex-row flex-col gap-[15px]">
        {(!!search || !!range[0] || !!range[1] || data?.length > 0) && <div className="flex items-center gap-[10px] xlsm:w-auto w-full justify-end xlsm:flex-row flex-col">
          <div className={`border border-[rgba(134,134,134,0.15)] h-[35px] xlx:h-[40px] px-[12px] xlx:px-[15px] flex items-center gap-[6px] xlx:gap-[9px] rounded-[6px] w-full xlsm:w-[280px] xlx:w-[315px] ${searchFocus && "shadow-xl"} hover:shadow-xl`}>
            <TableSearch className="xlx:w-[18px] xlx:min-w-[18px] xlx:h-[18px] min-w-[15px] w-[15px] h-[15px] fill-primary" />
            <input type="text" className="text-blackDull font-semibold placeholder:text-blackDull text-sm leading-snug w-full" placeholder={t("grievance.home.banner.search")} autoComplete="off" value={search} onChange={(e: any) => { setSearch(e.target.value) }} onFocus={() => setSearchFocus(true)} onBlur={() => setSearchFocus(false)} />
          </div>

          <div className="flex items-center gap-[10px] xlsm:w-auto w-full justify-end">
            <div className={`flex items-center justify-center gap-[6px] xlx:gap-[9px] rounded-[6px] h-[35px] xlx:h-[40px] border border-[rgba(134,134,134,0.15)] px-[12px] xlx:px-[15px] w-fit ${rangeFocus && "shadow-[0_0_0_2px_#059db25e]"} hover:shadow-[0_0_0_2px_#059db25e]`}>
              <DateRange />
              <DatePicker
                range
                value={range}
                onChange={(newRange: any) => {
                  if (!newRange || newRange.length === 0) {
                    setRange([null, null]);
                  } else {
                    setRange(newRange);
                  }
                }}
                numberOfMonths={2}
                placeholder="YYYY-MM-DD ~ YYYY-MM-DD"
                onOpen={() => setRangeFocus(true)}
                onClose={() => setRangeFocus(false)}
              />
            </div>

            {/* <button className="flex items-center justify-center h-[35px] xlx:h-[40px] min-w-[35px] xlx:min-w-[40px] rounded-[6px] border border-[#DDE2E4] bg-white focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e]">
              <OptionMenu />
            </button> */}
          </div>
        </div>}
      </div>

      {loading ?
        <div className="overflow-x-auto h-full w-full">
          <div className="inline-block min-w-full">
            <div className="overflow-hidden">
              <table className="table-auto w-full">
                <thead className="w-full">
                  <tr className="w-full border border-[#E7E8EC]">
                    <th className="px-[10px] py-[5px] xlx:py-[10px] h-full text-[#1A1F36] text-sm font-semibold leading-snug text-center">
                      {t("chatbot.list.no")}
                    </th>
                    <th className="px-[10px] py-[5px] xlx:py-[10px] h-full text-[#1A1F36] text-sm font-semibold leading-snug text-left">
                      {t("chatbot.list.word")}
                    </th>
                    <th className="px-[10px] py-[5px] xlx:py-[10px] h-full text-[#1A1F36] text-sm font-semibold leading-snug text-left">
                      {t("chatbot.list.lang")}
                    </th>
                    <th className="px-[10px] py-[5px] xlx:py-[10px] h-full text-[#1A1F36] text-sm font-semibold leading-snug text-center">
                      {t("chatbot.list.date_added")}
                    </th>
                    <th className="px-[10px] py-[5px] xlx:py-[10px] h-full"></th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                    <tr className="w-full animate-pulse border border-gray-200" key={index}>
                      <td className="px-[10px] py-[5px] xlx:py-[10px]">
                        <div className="flex items-center justify-center">
                          <div className="w-[20px] h-[12px] bg-gray-200 rounded-full"></div>
                        </div>
                      </td>

                      <td className="px-[10px] py-[5px] xlx:py-[10px]">
                        <div className="w-[90px] h-[12px] bg-gray-200 rounded-full"></div>
                      </td>

                      <td className="px-[10px] py-[5px] xlx:py-[10px]">
                        <div className="w-[90px] h-[12px] bg-gray-200 rounded-full"></div>
                      </td>

                      <td className="px-[10px] py-[5px] xlx:py-[10px]">
                        <div className="flex items-center justify-center">
                          <div className="w-[90px] h-[12px] bg-gray-200 rounded-full"></div>
                        </div>
                      </td>

                      <td className="px-[10px] py-[5px] xlx:py-[10px]">
                        <div className="flex items-center justify-end gap-[20px]">
                          <div className="w-[30px] min-w-[30px] h-[30px] bg-gray-200 rounded-[5px]"></div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        :
        <>
          {isError ? <Error /> : <>
            {data?.length > 0 && <>
              <div className="overflow-x-auto h-full w-full">
                <div className="inline-block min-w-full">
                  <div className="overflow-hidden">
                    <table className="table-auto w-full">
                      <thead className="w-full">
                        <tr className="w-full border border-[#E7E8EC]">
                          <th className="px-[10px] py-[5px] xlx:py-[10px] h-full text-[#1A1F36] text-sm font-semibold leading-snug text-center">
                            {t("chatbot.list.no")}
                          </th>
                          <th className="px-[10px] py-[5px] xlx:py-[10px] h-full text-[#1A1F36] text-sm font-semibold leading-snug text-left">
                            {t("chatbot.list.word")}
                          </th>
                          <th className="px-[10px] py-[5px] xlx:py-[10px] h-full text-[#1A1F36] text-sm font-semibold leading-snug text-left">
                            {t("chatbot.list.lang")}
                          </th>
                          <th className="px-[10px] py-[5px] xlx:py-[10px] h-full text-[#1A1F36] text-sm font-semibold leading-snug text-center">
                            {t("chatbot.list.date_added")}
                          </th>
                          <th className="px-[10px] py-[5px] xlx:py-[10px] h-full"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(data) && data.map((item: any, index: number) => (
                          <tr className="w-full border border-[#E7E8EC] bg-[#FAFCFE]" key={index}>
                            <td className="px-[10px] py-[5px] xlx:py-[10px] text-blackDull font-semibold text-sm text-center">
                              {(page - 1) * 10 + index + 1}
                            </td>
                            <td className="px-[10px] py-[5px] xlx:py-[10px] text-blackDull font-semibold text-sm text-left">
                              <h6 className="max-w-[81px]">
                                {item?.word}
                              </h6>
                            </td>
                            <td className="px-[10px] py-[5px] xlx:py-[10px] text-blackDull font-semibold text-sm text-left">
                              {languages?.find((l: any) => l?.value === item?.language)?.label}
                            </td>
                            <td className="px-[10px] py-[5px] xlx:py-[10px] text-blackDull font-semibold text-sm text-center whitespace-nowrap">
                              {moment(item?.created_at).format('DD MMM YYYY')}
                            </td>
                            <td className="px-[10px] py-[5px] xlx:py-[10px]">
                              <div className="flex items-center justify-end gap-[20px]">
                                <button aria-label={t("aria_label.delete")} title={t("aria_label.delete")} className="w-[30px] min-w-[30px] h-[30px] border border-[#E6E6E6] flex items-center justify-center rounded-[5px] shadow-[0px_6px_12px_-6px_rgba(24,39,75,0.12),0px_8px_24px_-4px_rgba(24,39,75,0.08)] focus:border-[#E02D005e] hover:border-[#E02D005e]" onClick={() => handleDelete(item?.id)}>
                                  <WordDelete />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center w-full mt-[10px]">
                <PaginationComponent
                  page={page}
                  total={totalPages}
                  setPage={setPage}
                />
              </div>
            </>}
            {(data?.length === 0 && (!!search || !!range[0] || !!range[1])) &&
              <NoSearch onClick={() => { setSearch(""); setRange([null, null]); }} />
            }

            {(data?.length === 0 && !!!search && !!!range[0] && !!!range[1]) &&
              <EmptyList />
            }
          </>}
        </>
      }
    </div>

  );
};

export default AlertWords;